import * as React from "react";
type Props = {
  className?: string,
};
function SvgCalendarOutline({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-calendar-outline"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5.5C6 4.67157 6.67157 4 7.5 4C8.32843 4 9 4.67157 9 5.5V6H15V5.5C15 4.67157 15.6716 4 16.5 4C17.3284 4 18 4.67157 18 5.5V6H19.5C20.3284 6 21 6.67157 21 7.5V19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5V7.5C3 6.67157 3.67157 6 4.5 6H6V5.5ZM5 8.5C5 8.22386 5.22386 8 5.5 8H18.5C18.7761 8 19 8.22386 19 8.5V9.5C19 9.77614 18.7761 10 18.5 10H5.5C5.22386 10 5 9.77614 5 9.5V8.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5V18.5C5 18.7761 5.22386 19 5.5 19H18.5C18.7761 19 19 18.7761 19 18.5V12.5C19 12.2239 18.7761 12 18.5 12H5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgCalendarOutline;
